import axios from "axios";
const axiosClient = axios.create({
  baseURL: "https://bill.svttransports.com/",
});

export default axiosClient;
